import type { ReactElement } from 'react'
import clsx from 'clsx'
import * as CountryFlags from 'country-flag-icons/react/3x2'

type FlagComponent = (props: { className?: string; 'aria-hidden'?: boolean }) => ReactElement

/**
 * The package exports one component per ISO 3166-1 alpha-2 code, but its typings name each of them
 * instead of exposing an index signature, so a lookup by runtime code needs this cast.
 */
const FLAG_COMPONENTS = CountryFlags as unknown as Record<string, FlagComponent>

export interface CountryFlagProps {
	/** ISO 3166-1 alpha-2 code, e.g. "VN". Case-insensitive. */
	code?: string | null
	className?: string
}

/**
 * CountryFlag - the 3:2 flag of a two-letter country code. Renders nothing for an unknown code, so the
 * caller decides the fallback.
 */
export function CountryFlag({ code, className }: Readonly<CountryFlagProps>) {
	const Flag = code ? FLAG_COMPONENTS[code.toUpperCase()] : undefined
	if (!Flag) return null

	return <Flag aria-hidden className={clsx('block h-3.5 w-5 flex-none rounded-[2px]', className)} />
}
